"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.username.placeholder': 'Enter your login',
};
